import styled from '@emotion/styled';

export const PopupWrapper = styled.div<{ isActive?: boolean }>`
  background: ${({ theme }): string => theme.WHITE};
  width: 282px;
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 13px;
  padding: 20px 30px;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  font-weight: 600;
  font-size: 12px;
  text-align: center;

  display: flex;
  flex-direction: column;
  align-items: center;

  transition: 0.3s ease;

  visibility: ${({ isActive }): string => (isActive ? 'visible' : 'hidden')};
  opacity: ${({ isActive }): string => (isActive ? '1' : '0')};

  z-index: 9999999;
`;

export const PopupCross = styled.div`
  position: absolute;
  top: 20px;
  right: 15px;
  cursor: pointer;
`;

export const PopupMessage = styled.div`
  width: 100%;
  border-radius: 5px;
  padding: 10px;
  margin: 16px 0px;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const PopupMessageSuccess = styled(PopupMessage)`
  background-color: ${({ theme }): string => `${theme.SUCCESS}1a`};
  color: ${({ theme }): string => theme.SUCCESS};

  svg * {
    fill: ${({ theme }): string => theme.SUCCESS};
  }
`;
export const PopupMessageError = styled(PopupMessage)`
  background-color: ${({ theme }): string => `${theme.ERROR}1a`};
  color: ${({ theme }): string => theme.ERROR};
`;

export const PopupMessageIcon = styled.div`
  margin-bottom: 6px;
`;

export const PopupDetails = styled.div`
  font-weight: 400;
  line-height: 19px;
`;
